// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kbSearchList__list___24dvJ{min-height:100px;flex-grow:1;overflow-y:auto}.kbSearchList__listLoading___x40q4{display:flex;align-items:center;justify-content:center;background-color:#fff}.kbSearchList__empty___24nG2{display:flex;flex-direction:column;align-items:center;text-align:center;padding:45px 20px 10px}.kbSearchList__emptyMessage___1XuoH{font-size:12px;margin-top:10px}.kbSearchList__headerContainer___2hYeq{background-color:#fff;padding:20px;border-bottom:1px solid #e9eff5}.kbSearchList__headerTitle___3kEA-{font-size:18px;font-weight:500;margin-bottom:10px}.kbSearchList__headerDescription___12FfR{color:#717070}@keyframes kbSearchList__animation-spinner___1lYP8{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}100%{transform:rotate(360deg)}}.kbSearchList__loader___3SU22{width:35px;height:35px;border-radius:100%;border-width:1px;border-style:solid;border-image:initial;border-color:#717070 #717070 #0000;display:inline-block;animation:kbSearchList__animation-spinner___1lYP8 1s linear infinite;background:#0000 !important}@keyframes kbSearchList__animation-spinner___1lYP8{0%{transform:rotate(0deg)}50%{transform:rotate(-180deg)}100%{transform:rotate(-360deg)}}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"list": "kbSearchList__list___24dvJ",
	"listLoading": "kbSearchList__listLoading___x40q4",
	"empty": "kbSearchList__empty___24nG2",
	"emptyMessage": "kbSearchList__emptyMessage___1XuoH",
	"headerContainer": "kbSearchList__headerContainer___2hYeq",
	"headerTitle": "kbSearchList__headerTitle___3kEA-",
	"headerDescription": "kbSearchList__headerDescription___12FfR",
	"loader": "kbSearchList__loader___3SU22",
	"animation-spinner": "kbSearchList__animation-spinner___1lYP8"
};
module.exports = exports;
